import { Accordion, AccordionTab } from "primereact/accordion";
import { ProgressBar } from "primereact/progressbar";
import { ProgressSpinner } from "primereact/progressspinner";
import { TabPanel, TabView } from "primereact/tabview";
import { Tooltip } from "primereact/tooltip";
import React, { useEffect, useState } from "react";
import {
  AiOutlineDown,
  AiOutlineUp,
  AiOutlineInfoCircle,
  AiFillInfoCircle 
} from "react-icons/ai";
import { Link, useNavigate, useParams } from "react-router-dom";
import iconDownload from "../../../assets/img/interna/download.png";
import ButtonZegel from "../../../components/Buttons/ButtonZegel";
import DialogZegel from "../../../components/Dialog/DialogZegel";
import { PrivateRoutes } from "../../../routes/routes";
import { ListarBibliotecasPorCurso } from "../../../services/BibliotecaServices";
import {
  CertificadoFCursoAdmi,
  CertificadoFCursoAdmiNotas,
} from "../../../services/CertificadosServices";
import {
  DescargarListaMaterialesCurso,
  DescargarListaMaterialesUnidad,
} from "../../../services/MaterialService";
import {
  ActualizarCursoEstado,
  ObtenerCertificadoPersonaCurso,
  SolicitarAmpliacion,
} from "../../../services/UsuarioService";
import Avance from "./Avance";
import "./ModulosAcordion.scss";
import useAlumno from "../../../hooks/useAlumno";
import { ObtenerCursosPorUsuario } from "../../../services/UsuarioService";
import { toast } from "react-toastify";
import { handleDownloadCertificado, urlToShare } from "../../../helpers/helpers";
import * as constantes from "../../../constants/constantes.js";

function ModulosAcordionProgramaComponent({
  idPrograma,
  listaCursoPrograma,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  Persona,
  curso,
  setListaBiblioteca,
  setcursoActivarSeleccion,
  cursoActivarSeleccion,
  LeccionesPendientesUnidadCurso
}) {
  const navigate = useNavigate();
  let { perfil } = useAlumno();
  let { idPersonaPrograma } = useParams();
  let { configuraciones } = useAlumno();
  const [isButtonDisabledMateriales, setButtonDisabledMateriales] =
    useState(false);
  const [isButtonDisabledCertificado, setButtonDisabledCertificado] =
    useState(false);
  const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);

  const [spinnerMateriales, setspinnerMateriales] = useState(false);
  const [spinnerCertificado, setspinnerCertificado] = useState(false);
  const [spinnerNotas, setspinnerNotas] = useState(false);
  const [showAlert, setShowAlert] = useState(null);
  const [LeccionesPendientes, setLeccionesPendientes] = useState([
    {
      idUnidad: 0,
      leccionesPendientes: [],
    },
  ]);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);
  const [progreso, setProgreso] = useState(null);
  const [idCursosRepetidos, setIdCursosRepetidos] = useState([]);

  let idCursosRepet=[];
  let jwt = window.localStorage.getItem("jwt");

  useEffect(() => {
    if (listaCursoPrograma !== null) {
      let idUsuario = perfil.idUsuario;
      ObtenerCursosPorUsuario({ jwt, idUsuario }).then((data) => {
        const idCursos = data.map((curso) => [curso.idCurso, curso.idPersonaCurso]);
        const idCursosPersonaPrograma = listaCursoPrograma?.map((curso) => [curso.idCurso, curso.idPersonaCurso]);
        idCursosPersonaPrograma.forEach(element => {
          idCursos?.forEach(elementidCursos => {
            if(elementidCursos[0]==element[0] && elementidCursos[1] < element[1]){
              idCursosRepet.push(element[0])
            }            
          });
        });
        /* idCursosRepet = idCursos.filter(
          (idCurso, index) => idCursos.indexOf(idCurso) !== index
        ); */
        setIdCursosRepetidos(idCursosRepet);
      });
    }
  }, [listaCursoPrograma]);

  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Activar módulo"
          color="primary"
          onClick={() => Actualizar()}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAlert(false)}
        ></ButtonZegel>
      </div>
    </>
  );
  const [ProgresoUnidad, setProgresoUnidad] = useState([
    {
      idUnidad: 0,
      promedioPorcentaje: 0,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [showErrorMateriales, setShowErrorMateriales] = useState(false);

  const [showAmpliacion, setShowAmpliacion] = useState(false);
  const [IdPersonaCursoSolicitudAmpliacion, setIdPersonaCursoSolicitudAmpliacion] = useState(0);
  const NewExpandIcontemplate = (
    <span className="icon-acordeon">
      <AiOutlineDown />
    </span>
  );
  const NewCollapseIcontemplate = (
    <span className="icon-acordeon">
      <AiOutlineUp />
    </span>
  );
  const expandIcontemplate = (
    <span className="icon-acordeon">
      <img
        alt="Ícono de filtro"
        height={7}
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCA2IDUiPgogIDxwYXRoIGlkPSJtdWx0aW1lZGlhIiBkPSJNNC45MywyLjg4Mi4yNTMuMDI1QS4xOC4xOCwwLDAsMCwuMDg2LjAxNi4xNDIuMTQyLDAsMCwwLDAsLjE0M1Y1Ljg1N2EuMTQyLjE0MiwwLDAsMCwuMDg2LjEyN0EuMTguMTgsMCwwLDAsLjE2MSw2YS4xNzcuMTc3LDAsMCwwLC4wOTItLjAyNUw0LjkzLDMuMTE4YS4xMzQuMTM0LDAsMCwwLDAtLjIzNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkgcm90YXRlKC05MCkiIGZpbGw9IiMyYjJiMmIiLz4KPC9zdmc+Cg=="
      ></img>
    </span>
  );
  const CollapseIcontemplate = (
    <span className="icon-acordeon">
      <img
        alt="Ícono de filtro"
        height={7}
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCA2IDUiPgogIDxwYXRoIGlkPSJtdWx0aW1lZGlhIiBkPSJNNC45MywyLjg4Mi4yNTMuMDI1QS4xOC4xOCwwLDAsMCwuMDg2LjAxNi4xNDIuMTQyLDAsMCwwLDAsLjE0M1Y1Ljg1N2EuMTQyLjE0MiwwLDAsMCwuMDg2LjEyN0EuMTguMTgsMCwwLDAsLjE2MSw2YS4xNzcuMTc3LDAsMCwwLC4wOTItLjAyNUw0LjkzLDMuMTE4YS4xMzQuMTM0LDAsMCwwLDAtLjIzNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkgcm90YXRlKC05MCkiIGZpbGw9IiMyYjJiMmIiLz4KPC9zdmc+Cg=="
      ></img>
    </span>
  );
  const handleChangeAccordion = async (e) => {
    var auxsetListaBiblioteca = [];
    var idCurso = listaCursoPrograma[e].idCurso;
    let jwt = window.localStorage.getItem("jwt");
    await ListarBibliotecasPorCurso({ jwt, idCurso }).then((data) => {
      for (var B = 0; B < data.length; B++) {
        auxsetListaBiblioteca.push(data[B]);
      }
      setListaBiblioteca(auxsetListaBiblioteca);
    });
  };
  const contenidoActivar = (
    <div>
      <span>
        <strong>
          {"¿Estás seguro de que quieres activar el módulo" +
            curso.nombre +
            "?"}
        </strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Recuerda que tienes 30 días para culminar el módulo, una vez comenzado
        no podrás desactivarlo.{" "}
      </span>
    </div>
  );
  const handleLinkClickCursoBase = (idCursoPersona) => {
    navigate(
      "/" +
        PrivateRoutes.HOME +
        "/CursoInterno/" +
        idCursoPersona +
        "/0/0/" +
        idPersonaPrograma
    );
  };
  function ProgresoProgramaCursoPormedio(props) {
    if (
      listaProgresoLeccionUnidadeCursoPrograma &&
      listaProgresoLeccionUnidadeCursoPrograma
    ) {
      var Sum = listaProgresoLeccionUnidadeCursoPrograma
        .filter((x) => x.idCurso === props.idCurso)
        .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === props.idCurso
      );
      var auxListadeLeccionesPorUnidad = [];
      var evaluacionCurso = 0;
      for (var i = 0; i < UnidadesPorCurso.length; i++) {
        var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
          (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
        );
        for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
          auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
        }
        var evaluacionCursoFilter =
          listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) =>
              x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
          );
        evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
      }
      const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
      const evaluacionPorcentaje =
        (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;

      return <span>{(PorcentajeCurso + evaluacionPorcentaje).toFixed()}</span>;
    } else {
      return <span>0.00</span>;
    }
  }
  function ProgresoProgramaCursoPormedioProgressBar(props) {
    if (listaProgresoLeccionUnidadeCursoPrograma != null) {
      var Sum = listaProgresoLeccionUnidadeCursoPrograma
        .filter((x) => x.idCurso === props.idCurso)
        .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      var UnidadesPorCurso = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === props.idCurso
      );
      var evaluacionCurso = 0;
      var auxListadeLeccionesPorUnidad = [];
      for (var i = 0; i < UnidadesPorCurso.length; i++) {
        var LeccionesPOrUnidad = listaLeccionUnidadeCursoPrograma.filter(
          (x) => x.idUnidad === UnidadesPorCurso[i].idUnidad
        );
        for (var j = 0; j < LeccionesPOrUnidad.length; j++) {
          auxListadeLeccionesPorUnidad.push(LeccionesPOrUnidad[j]);
        }
        var evaluacionCursoFilter =
          listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) =>
              x.idUnidad === UnidadesPorCurso[i].idUnidad && x.intento === 1
          );
        evaluacionCurso = evaluacionCurso + evaluacionCursoFilter.length;
      }
      const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length / 2;
      const evaluacionPorcentaje =
        (evaluacionCurso * 100) / UnidadesPorCurso.length / 2;
      return (
        <ProgressBar
          style={{ height: "8px", borderRadius: 0 }}
          color={props.Color ? props.Color : "#FFB62F"}
          value={PorcentajeCurso + evaluacionPorcentaje?evaluacionPorcentaje:0}
        ></ProgressBar>
      );
    } else {
      return (
        <ProgressBar
          style={{ height: "8px", borderRadius: 0 }}
          color="#FFB62F"
          value={0}
        ></ProgressBar>
      );
    }
  }
  const handleDownloadNotas = async (idCurso) => {
    var cursoDat = listaCursoPrograma.filter((x) => x.idCurso === idCurso);
    let jwt = window.localStorage.getItem("jwt");
     const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
    let IdPersonaCurso = cursoDat[0].idPersonaCurso;
    ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso }).then(
      async (dataCert) => {
        var unidadesDat = listaUnidadeCursoPrograma.filter(
          (x) => x.idCurso === idCurso
        );
        let jwt = window.localStorage.getItem("jwt");
        let nombrealumno =
          (Persona.nombres == null ? " " : Persona.nombres.trim()) +
          " " +
          (Persona.primerApellido == null ? " " : Persona.primerApellido.trim()) +
          " " +
          (Persona.segundoApellido == null ? " " : Persona.segundoApellido.trim());
        let nombrecursoprograma = cursoDat[0].curso.nombre;
        let ubicacion = "Lima";
        let enlace = urlToShare //dataCert.LinkCDN
            ? `${urlToShare}${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
            : '';
        const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-${"DN_"+dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
        const codigo = dataCert.codigoCertificado;
        const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=2";
        let promedionotaD = 0;
        var detalle = [];
        for (var j = 0; j < unidadesDat.length; j++) {
          var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) => x.idUnidad === unidadesDat[j].idUnidad
          );
          let notas;
          let notaMasAlta = 0;
          if (evaluacionesUnidad.length > 0) {
            notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
            notaMasAlta = Math.max(...notas);
          }
          let detalleUnidad = {
            nombremodulo: unidadesDat[j].descripcion,
            promedio: notaMasAlta,
            orden: j + 1,
          };
          promedionotaD = promedionotaD + notaMasAlta;
          detalle.push(detalleUnidad);
        }
        promedionotaD = (promedionotaD / unidadesDat.length).toFixed();
        let promedionota = promedionotaD.toString();
        let jsonData = JSON.stringify({
          nombrealumno,
          nombrecursoprograma,
          ubicacion,
          enlace,
          enlaceQR,
          codigo,
          promedionota,
          detalle,
        });
          const dataCDN = {
              Extension: enlace.split('.').pop(),
              NombreCDN: fileName
          };
        try {
          setspinnerNotas(true);
          setButtonDisabledNotas(true);
          const response = { link: enlace, fileName };
          await CertificadoFCursoAdmiNotas({ jwt, jsonData, dataCDN, response }).then(
            (data) => {}
          );
          setButtonDisabledNotas(false);
          setspinnerNotas(false);
        } catch (error) {
          setspinnerNotas(false);
          alert.error("Error en la función CertificadoFCursoAdmi:", error);
        }
      }
    );
  };

  function duracionEnHoras(duracion) {
    const partes = duracion.split(" ");
    if (partes.length === 2 && partes[1] === "h") {
      return parseFloat(partes[0]);
    }
    return 0;
  }
  const onDownloadCertificado = async(curso) => {
          try{
              navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/InternalCourse/" + idPrograma + "/" + idPersonaPrograma + "/" + curso.idCurso,{
                state: {downloading:true}
              });

              const res = await handleDownloadCertificado({
                  cursoPersona: listaCursoPrograma,
                  curso,
                  persona: Persona,
                  tipo:"InternalCourse"
              });
  
              console.log('urlCertificado',res)
              navigate("/" + PrivateRoutes.HOME + "/ShareCertificate/InternalCourse/" + idPrograma + "/" + idPersonaPrograma + "/" + curso.idCurso,{
                state: {downloading: false, res}
              });
  
          }catch(error){
              toast.error(error,{ autoClose: 3000})
          }
    };

  const handleDownloadMaterialesCursoold = async (idCurso) => {
    try {
      let jwt = window.localStorage.getItem("jwt");
      setButtonDisabledMateriales(true);
      setspinnerMateriales(true);
      await DescargarListaMaterialesCurso({ jwt, idCurso }).then((data) => {
        const byteCharacters = atob(data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/octet-stream",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        var cursoFilter = listaCursoPrograma.filter(
          (x) => x.idCurso === idCurso
        );
        link.setAttribute(
          "download",
          cursoFilter[0].curso.nombre + "_Materiales.zip"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        setButtonDisabledMateriales(false);
        setspinnerMateriales(false);
      });
      setButtonDisabledMateriales(false);
      setspinnerMateriales(false);
    } catch (error) {
      // alert("Error al descargar materiales del módulo");
      setShowErrorMateriales(true);
      setButtonDisabledMateriales(false);
      setspinnerMateriales(false);
    }
  };

  const handleDownloadMaterialesCurso = async (idCurso) => {
    var listaUnidades = listaUnidadeCursoPrograma.filter(
      (x) => x.idCurso === idCurso
    );
    for (var i = 0; i < listaUnidades.length; i++) {
      try {
        let jwt = window.localStorage.getItem("jwt");
        setButtonDisabledMateriales(true);
        setspinnerMateriales(true);
        const data = await DescargarListaMaterialesUnidad({
          jwt,
          idUnidad: listaUnidades[i].idUnidad,
        });
        const byteCharacters = atob(data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/octet-stream",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          listaUnidades[i].descripcionSEO + "_Materiales.zip"
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        setButtonDisabledMateriales(false);
        setspinnerMateriales(false);
      } catch (error) {
        alert("Error al descargar materiales del curso");
        setButtonDisabledMateriales(false);
        setspinnerMateriales(false);
      }
    }
  };
  function UnidadEvaluacion(props) {
    if (listaEvaluacionesUnidadeCursoPrograma) {
      var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
        (x) => x.idUnidad === props.idUnidad
      );
      let PorcentajedeCurso = 0;
      if (listaProgresoLeccionUnidadeCursoPrograma != null) {
        var Sum = listaProgresoLeccionUnidadeCursoPrograma
          .filter(
            (x) => x.idCurso === props.idCurso && x.idUnidad === props.idUnidad
          )
          .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
        var LeccionesPorUnidad = listaLeccionUnidadeCursoPrograma.filter(
          (x) => x.idUnidad === props.idUnidad
        );
        var auxListadeLeccionesPorUnidad = [];
        for (var j = 0; j < LeccionesPorUnidad.length; j++) {
          auxListadeLeccionesPorUnidad.push(LeccionesPorUnidad[j]);
        }
        PorcentajedeCurso = Sum / auxListadeLeccionesPorUnidad.length;
      } else {
      }
      if (evaluacionesUnidad.length > 0) {
        const notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
        const notaMasAlta = Math.max(...notas);
        const cantidadElementos = notas.length;
        return (
          <>
            <span
              className={
                cantidadElementos == 2 ||
                notaMasAlta >=
                  configuraciones?.filter(
                    (z) => z.codigo === "NOTA_MINIMA_APROB"
                  )[0].valor
                  ? "evaluacion_font__size Evaluacion1"
                  : "evaluacion_font__size Evaluacion1"
              }
            >
              Evaluación:{" "}
              <span
                style={notaMasAlta <  configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor ? { color: "red" } : { color: "black" }}
              >
                {notaMasAlta <  configuraciones?.filter(z => z.codigo === "NOTA_MINIMA_APROB")[0].valor ? notaMasAlta <= 9?  "0" + notaMasAlta: notaMasAlta : notaMasAlta}
              </span>
            </span>
            <Tooltip
              target=".Evaluacion1"
              content="¡Recuerda dar tu evaluación! Te queda un intento"
              className="white-tooltip"
              position="left"
            />
          </>
        );
      } else {
        return (
          <>
            <span
              //  className={
              //   (ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje > 0
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje < 100)
              //   || (ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje === 100
              //     && evaluacionesUnidad.length === 0)
              //     ? "evaluacion_font__size Evaluacion1"
              //     : "evaluacion_font__size"
              // }
              // className={
              //   (ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje > 0
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje < 100)
              //   || (ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
              //     && ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0].promedioPorcentaje === 100
              //     && evaluacionesUnidad.length === 0)
              //     ? "evaluacion_font__size Evaluacion1"
              //     : "evaluacion_font__size "
              // }
              className={
                (PorcentajedeCurso >= 0 && PorcentajedeCurso < 100) ||
                (PorcentajedeCurso === 100 && evaluacionesUnidad.length === 0)
                  ? "evaluacion_font__size  EvaluacionTooltip"
                  : "evaluacion_font__size "
              }
            >
              Evaluación: --
            </span>
            <Tooltip
              target=".EvaluacionTooltip"
              content="¡Recuerda dar tu evaluación! Revisa que hayas completado al 
                menos un intento con nota aprobatoria"
              className="white-tooltip"
              position="left"
            />
          </>
        );
      }
    } else {
      return <span className="evaluacion_font__size ">Evaluación: --</span>;
    }
  }
  const handleLinkClickCursos = (idCursoPersona, unidad, leccion) => {
    navigate(
      "/" +
        PrivateRoutes.HOME +
        "/CursoInterno/" +
        idCursoPersona +
        "/" +
        unidad.idUnidad +
        "/" +
        leccion.idLeccion +
        "/" +
        idPersonaPrograma
    );
  };
  function ProgresoProgramaCursoUnidadPormedioProgressBar(props) {
    if (listaProgresoLeccionUnidadeCursoPrograma != null) {
      var Sum = listaProgresoLeccionUnidadeCursoPrograma
        .filter(
          (x) => x.idCurso === props.idCurso && x.idUnidad === props.idUnidad
        )
        .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      var LeccionesPorUnidad = listaLeccionUnidadeCursoPrograma.filter(
        (x) => x.idUnidad === props.idUnidad
      );
      var auxListadeLeccionesPorUnidad = [];
      for (var j = 0; j < LeccionesPorUnidad.length; j++) {
        auxListadeLeccionesPorUnidad.push(LeccionesPorUnidad[j]);
      }
      const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length;
      return (
        <>
          <ProgressBar
            className={"ProgressBar" + props.idUnidad}
            style={{ height: "8px", borderRadius: 0 }}
            value={PorcentajeCurso.toFixed(2)}
          ></ProgressBar>

          <Tooltip
            target={".ProgressBar" + props.idUnidad}
            content={
              PorcentajeCurso>0 && PorcentajeCurso<100?
              "¡Termina tus videos! \nAún no has culminado \nla(s) lección(es): " +
                    LeccionesPendientesUnidadCurso.filter(
                      (x) => x.idUnidad == props.idUnidad && x.idCurso== props.idCurso
                    )[0].leccionesPendientes.join(",")
                  : ""
              /* ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
                ? ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
                    .promedioPorcentaje > 0 &&
                  ProgresoUnidad.filter((x) => x.idUnidad == props.idUnidad)[0]
                    .promedioPorcentaje < 100
                  ? "¡Termina tus videos! Aún no has culminado la(s) lección(es): " +
                    LeccionesPendientesUnidadCurso.filter(
                      (x) => x.idUnidad == props.idUnidad && x.idCurso== props.idCurso
                    )[0].leccionesPendientes.join(",")
                  : ""
                : "" */
            }
            className="white-tooltip"
          />
        </>
      );
    } else {
      return (
        <ProgressBar
          className={"ProgressBar" + props.idUnidad}
          style={{ height: "8px", borderRadius: 0 }}
          value={0}
        ></ProgressBar>
      );
    }
  }
  function ProgresoProgramaCursoUnidadPormedio(props) {
    if (listaProgresoLeccionUnidadeCursoPrograma != null) {
      var Sum = listaProgresoLeccionUnidadeCursoPrograma
        .filter(
          (x) => x.idCurso === props.idCurso && x.idUnidad === props.idUnidad
        )
        .reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      var LeccionesPorUnidad = listaLeccionUnidadeCursoPrograma.filter(
        (x) => x.idUnidad === props.idUnidad
      );
      var auxListadeLeccionesPorUnidad = [];
      for (var j = 0; j < LeccionesPorUnidad.length; j++) {
        auxListadeLeccionesPorUnidad.push(LeccionesPorUnidad[j]);
      }
      const PorcentajeCurso = Sum / auxListadeLeccionesPorUnidad.length;
      setProgreso(PorcentajeCurso);
      return (
        <span  className={"ProgressBar" + props.idUnidad} style={{ color: "blue" }}>{Math.round(PorcentajeCurso)}%</span>
      );
    } else {
      return <span  className={"ProgressBar" + props.idUnidad} style={{ color: "blue" }}>0%</span>;
    }
  }

  //esv 23-04-25 -5

  // 1. Devuelve solo el número (útil para lógica de aprobación, condiciones, etc.)
const obtenerPromedioNumerico = (idCurso) => {
  if (!listaEvaluacionesUnidadeCursoPrograma || !listaUnidadeCursoPrograma) return null;

  const unidades = listaUnidadeCursoPrograma.filter(u => u.idCurso === idCurso);
  if (unidades.length === 0) return null;

  const total = unidades.reduce((sum, unidad) => {
    const evaluaciones = listaEvaluacionesUnidadeCursoPrograma.filter(
      e => e.idUnidad === unidad.idUnidad
    );
    if (evaluaciones.length > 0) {
      const notaMasAlta = Math.max(...evaluaciones.map(e => e.nota));
      return sum + notaMasAlta;
    }
    return sum;
  }, 0);
  
  return parseFloat((total / unidades.length).toFixed(0));

  //const promedio = 12.4
  //return parseFloat((promedio).toFixed(1));
};

// 2. Muestra visual del promedio
const VistaPromedio = (promedio) => {
  const esNumerico = !isNaN(promedio);
  const promedioNum = parseFloat(promedio);
  const promedioAprobado = configuraciones?.filter((z) => z.codigo === "NOTA_MINIMA_APROB" )[0].valor;

  const getColor = () =>
    !esNumerico ? "black" : promedioNum < promedioAprobado ? "red" : "black";

  return (
    <>
      {esNumerico && (
        <Tooltip
          target=".promedio-tooltip"
          position="top"
          className="white-tooltip"
          content={
            promedioNum < promedioAprobado
              ? "Recuerda que para obtener tu certificado debes contar con al menos 13 puntos en el promedio"
              : "¡Felicitaciones! Obtuviste una nota aprobatoria."
          }
        />
      )}
      <span
        className="subtitle h4 promedio-tooltip"
        data-pr-tooltip={
          promedioNum < promedioAprobado
            ? "Recuerda que para obtener tu certificado debes contar con al menos 13 puntos en el promedio"
            : "¡Felicitaciones! Obtuviste una nota aprobatoria."
        }
      >
        Promedio total del módulo:{" "}
        <span style={{ color: getColor(), fontWeight: "bold" }}>{promedio}</span>
      </span>
    </>
  );
};

// 3. Combinas para renderizar en pantalla
const calcularPromedioNotasPorUnidad = (idCurso) => {
  const promedio = obtenerPromedioNumerico(idCurso);
  return VistaPromedio(promedio ?? "--");
};
//end esv 23-04-25 -5

  const Actualizar = () => {
    setLoading(true);
    let idPersonaCurso =
      listaCursoPrograma[cursoActivarSeleccion].idPersonaCurso;
    let idCurso = listaCursoPrograma[cursoActivarSeleccion].idCurso;
    let finCurso = listaCursoPrograma[cursoActivarSeleccion].finCurso;
    let idUsuario = listaCursoPrograma[cursoActivarSeleccion].idUsuario;
    let idEstado = 2;
    let jsonCurso = JSON.stringify(
      { idPersonaCurso, idUsuario, idCurso, finCurso, idEstado },
      null,
      2
    );
    let jwt = window.localStorage.getItem("jwt");

    ActualizarCursoEstado({ jsonCurso, jwt }).then((data) => {
      setTimeout(() => {
        setShowAlert(false);
        //window.location.reload();
        navigate("/" + PrivateRoutes.HOME + "/CursoInterno/" + idPersonaCurso);
      }, 3000);
      setLoading(false);
    });
  };

  function DiasVigencia({
    fechaAmpliacionCurso,
    fechaVigencia,
    fechaVigenciaMembresia,
  }) {
    let fechaActual = new Date();

    // if (listaCursoPrograma.idCurso === curso.idCurso) {

    // }
    let diferenciaEnDias = 0;

    let fechaVigenciaMmebresia = new Date(fechaVigenciaMembresia);

    let fechaCalculable = fechaAmpliacionCurso
      ? new Date(fechaAmpliacionCurso)
      : new Date(fechaVigencia);

    let fechaCalculableFinal = fechaVigenciaMembresia
      ? fechaCalculable > fechaVigenciaMmebresia
        ? fechaVigenciaMmebresia
        : fechaCalculable
      : fechaCalculable;
    let diferenciaEnMilisegundos = fechaCalculableFinal - fechaActual;

    // let diferenciaEnMilisegundos =
    //   (fechaAmpliacionCurso
    //     ? new Date(fechaAmpliacionCurso)
    //     : new Date(fechaVigencia)) - fechaActual;
    diferenciaEnDias = Math.floor(
      diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
    );
    // if (diferenciaEnDias <= 4 && AlertaEstaPorvencer == false) {
    //   setShowEstaPorvencer(true);
    // }
    return <span>{diferenciaEnDias + 1}</span>;
  }

  function DiasVigenciaValue(
    fechaAmpliacionCurso,
    fechaVigencia,
    fechaVigenciaMembresia,
  ) {
    let fechaActual = new Date();
    let diferenciaEnDias = 0;
    let fechaVigenciaMmebresia = new Date(fechaVigenciaMembresia);
    let fechaCalculable = fechaAmpliacionCurso
      ? new Date(fechaAmpliacionCurso)
      : new Date(fechaVigencia);
    let fechaCalculableFinal = fechaVigenciaMembresia
      ? fechaCalculable > fechaVigenciaMmebresia
        ? fechaVigenciaMmebresia
        : fechaCalculable
      : fechaCalculable;
    let diferenciaEnMilisegundos = fechaCalculableFinal - fechaActual;
    diferenciaEnDias = Math.floor(
      diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)
    );
    return diferenciaEnDias + 1;
  }
  const solicitaAmpliacion = () => {
    if (IdPersonaCursoSolicitudAmpliacion > 0) {
      setLoading(true);
      let jwt = window.localStorage.getItem("jwt");
      let id = IdPersonaCursoSolicitudAmpliacion;
      SolicitarAmpliacion({ jwt, id })
        .then((data) => {
          setTimeout(() => {
            setLoading(false);
            setShowAmpliacion(false);
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };
  const footerAmpliacion = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Aceptar ampliación"
          color="primary"
          onClick={() => solicitaAmpliacion()}
          loading={loading}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAmpliacion(false)}
        ></ButtonZegel>
      </div>
    </>
  );
  const footerErrorMateriales = (
    <>
      <div>
        <ButtonZegel
          label="Cerrar"
          color="primary"
          onClick={() => setShowErrorMateriales(false)}
        ></ButtonZegel>
      </div>
    </>
  );
  const contenidoAmpliacion = (
    <div>
      <span>
        <strong>{"Recuerda que..."}</strong>
      </span>
      <br></br>
      <br></br>
      <span style={{ fontSize: 12 }}>
        Tienes 14 días más para culminar con el curso. Luego de esta ampliación
        el curso quedará expirado permanentemente..{" "}
      </span>
    </div>
  );
  const contenidoErrorMateriales = (
    <div>
      <span>
        <strong>{"Ocurrió un error al descargar materiales..."}</strong>
      </span>
      <br></br>
      <br></br>
      <span style={{ fontSize: 12 }}>Intenta nuevamente por favor.</span>
    </div>
  );   

  return (
    <div style={{ marginBottom: "30px" }}>
      <div className="p-fluid formgrid grid ">
        <div className="field col-12 md:col-12 contenedor_titulo_header ">
          <b className="titulo_header">Abre el módulo que deseas ver</b>
        </div>
      </div>

      <div className=" ">
        <Accordion
          activeIndex={0}
          expandIcon={NewExpandIcontemplate}
          collapseIcon={NewCollapseIcontemplate}
          onTabOpen={(e) => handleChangeAccordion(e.index)}
        >
          {listaCursoPrograma &&
            listaCursoPrograma.map((item, i) => {
              const estaRepetido = idCursosRepetidos.includes(item.idCurso);

              //esv 21-04-25 Promedio
              const promedioNumerico = obtenerPromedioNumerico(item.idCurso);
              const notaMinima = parseFloat(
                configuraciones?.find((z) => z.codigo === "NOTA_MINIMA_APROB")?.valor || 13
              );
              const puedeDescargar =
                item.idEstado === 1 &&
                item.idCondicion !== 2 &&
                isButtonDisabledCertificado === false &&
                listaEvaluacionesUnidadeCursoPrograma &&
                promedioNumerico >= notaMinima;
              //end esv 21-04-25
              return (
                <AccordionTab
                  style={{ width: "100%" }}
                  header={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      Módulo {i + 1}: {item.curso.nombre}
                      {estaRepetido && (
                        <>
                          <span
                            className="icon-info"
                            style={{ color: "yellow" }}
                          >
                            <AiFillInfoCircle  />
                          </span>
                          <Tooltip
                            target=".icon-info"
                            content="Este módulo ya lo llevaste anteriormente"
                            className="white-tooltip"
                            position="left"
                          />
                        </>
                      )}
                    </div>
                  }

                  // header={
                  //   <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between' }}>
                  //     Módulo {i + 1}: {item.curso.nombre}
                  //     <span className="icon-info" style={{ color: 'yellow' }}>
                  //       <AiOutlineInfoCircle />
                  //     </span>
                  //     <Tooltip
                  //       target=".icon-info"
                  //       content="Este módulo ya lo llevaste anteriormente"
                  //       className="white-tooltip"
                  //     />

                  //   </div>
                  // }
                  // header={"Módulo " + (i + 1) + ": " + item.curso.nombre}
                >
                  <div className="contenedor_modulo">
                    <div className="p-fluid formgrid grid">
                      <div className="field col-12 md:col-7">
                        <div
                          className="border rounded-9 shadow  p-md-4 mb-md-4 cardTabs"
                          style={{ border: "#dee2e6 solid 1px" }}
                        >
                          <div
                            className="row g-2 mb-2 align-items-center"
                            style={{ height: "100%" }}
                          >
                            <div
                              className="rounded-10 p-2 p-md-4 mb-md-4"
                              style={{ marginTop: "10px" }}
                            >
                              <div className="p-fluid formgrid grid">
                                {item.fechaVigenciaMembresia && 
                                new Date(
                                  item.fechaVigenciaMembresia) <= new Date()
                                 ? (
                                  item.idCondicion ?(
                                    item.idCondicion == 2 ? (
                                      <>
                                        <span  class="subtitle fontsizeinitial h3">
                                          Promedio desaprobado: {item.promedio}
                                        </span>
                                        <span  class="subtitle fontsizeinitial h3">
                                          No puedes descargar el certificado.
                                        </span>
                                      </>
                                    ) : (
                                      <span  class="subtitle fontsizeinitial h3">Promedio aprobado: {item.promedio}</span>
                                    )
                                  )
                                  :
                                  (<>
                                    <span
                                      class="subtitle fontsizeinitial h3"
                                      data-v-48f3e599=""
                                    >
                                      El módulo "{item.curso.nombre}" ha
                                      expirado, tu membresia ha finalizado.
                                    </span>
                                    {/* <span className="fontsizeinitial">
                                                    Puedes solicitar una única ampliación de 14 dias{" "}
                                                    <br />
                                                  
                                                </span> */}
                                  </>)
                                  
                                ) : item.idEstado == 3 ? (
                                  <div className="field col-12 md:col-8 fontsizeinitial">
                                    <div className="fontsizeinitialMargin">
                                      <span
                                        class="subtitulo_progreso fontsizeinitial h3"
                                        data-v-48f3e599=""
                                        style={{ color: "black" }}
                                      >
                                        Recuerda que...
                                      </span>
                                      <span className="subtitulo_progreso_description">
                                        Tienes 30 días para culminar el módulo
                                        desde que lo activas,una vez comenzado
                                        no podrás desactivarlo.
                                      </span>
                                    </div>
                                  </div>
                                ) : item.idEstado == 2 ? (
                                  <div className="field col-12 md:col-8 fontsizeinitial">
                                    <div className="fontsizeinitialMargin">
                                      <span
                                        class="subtitulo_progreso fontsizeinitial h3"
                                        data-v-48f3e599=""
                                        style={{ color: "black" }}
                                      >
                                        Progreso del módulo
                                      </span>
                                      {item.diasFaltantes > 0 ? (
                                        <>
                                          <span className="subtitulo_progreso_description ">
                                            Has avanzado el{" "}
                                            <ProgresoProgramaCursoPormedio
                                              idCurso={item.idCurso}
                                            />{" "}
                                            % del módulo
                                          </span>
                                          <span
                                            className=""
                                            style={{ fontSize: "11px" }}
                                          >
                                            |{" "}
                                          </span>

                                          <span
                                            style={{
                                              color: DiasVigenciaValue(item.fechaAmpliacionCurso,item.fechaVigencia,item.fechaVigenciaMembresia) <= 7 ? "red" : "inherit",
                                            }}

                                            className="avance_description_responsive"
                                          >
                                            Vence en{" "}
                                            <DiasVigencia
                                              fechaAmpliacionCurso={
                                                item.fechaAmpliacionCurso
                                              }
                                              fechaVigencia={item.fechaVigencia}
                                              fechaVigenciaMembresia={
                                                item.fechaVigenciaMembresia
                                              }
                                            />{" "}
                                            días
                                          </span>
                                        </>
                                      ) : (
                                        <span className="subtitulo_progreso_description ">
                                          El módulo ha terminado, puedes
                                          solicitar una única ampliación de 14
                                          días.
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  item.idCondicion == 2 ?(
                                  <div className="field col-12 md:col-8 fontsizeinitial">
                                    <div className="fontsizeinitialMargin">
                                      <span
                                        class="subtitulo_progreso fontsizeinitial h3"
                                        data-v-48f3e599=""
                                        style={{ color: "black" }}
                                      >
                                        ¡Lo sentimos {perfil.nombres}!
                                      </span>
                                      <span className="subtitulo_progreso_description">
                                        Desaprobaste el módulo {item.curso.nombre}, 
                                        no podrás obtener tu certificado, sin embargo, 
                                        si deseas continuar con tu desarrollo académico, puedes seguir revisando el curso.
                                      </span>
                                    </div>
                                  </div>
                                  ):item.idCondicion == 1 ?
                                  (
                                    <div className="field col-12 md:col-8 fontsizeinitial">
                                      <div className="fontsizeinitialMargin">
                                        <span
                                          class="subtitulo_progreso fontsizeinitial h3"
                                          data-v-48f3e599=""
                                          style={{ color: "black" }}
                                        >
                                          ¡Felicidades {perfil.nombres}!
                                        </span>
                                        <span className="subtitulo_progreso_description">
                                          Culminaste satisfactoriamente tu módulo {item.curso.nombre}
                                        </span>
                                          </div>
                                        </div>
                                      ) :
                                      <div className="field col-12 md:col-8 fontsizeinitial">
                                        <div className="fontsizeinitialMargin">
                                          <span
                                            class="subtitulo_progreso fontsizeinitial h3"
                                            data-v-48f3e599=""
                                            style={{ color: "black" }}
                                          >
                                            Recuerda que...
                                          </span>
                                          <span className="subtitulo_progreso_description">
                                            Tienes 30 días para culminar el módulo
                                            desde que lo activas, una vez comenzado
                                            no podrás desactivarlo.
                                          </span>
                                        </div>
                                      </div>
                                  )}
                                <div
                                  style={{ marginTop: 10 }}
                                  className=" field col-12 ml-4 md:col-4 progreso_barra_visibilidad"
                                >
                                  <div className="progreso_barra">
                                    <ProgresoProgramaCursoPormedioProgressBar
                                      idCurso={item.idCurso}
                                      Color="#6366F1"
                                      className=""
                                    />
                                  </div>
                                </div>
                                <div className="field col-12 md:col-4 xl:col-4">
                                  {item.fechaVigenciaMembresia &&
                                  new Date(
                                    item.fechaVigenciaMembresia <= new Date()
                                  ) ? (
                                    <div className="btn_progreso">
                                      <ButtonZegel
                                        label="¡Seguir aprendiendo!"
                                        color="primary"
                                        height="60px !important"
                                        onClick={() =>
                                          handleLinkClickCursoBase(
                                            item.idPersonaCurso
                                          )
                                        }
                                      ></ButtonZegel>
                                    </div>
                                  ) : item.diasFaltantes === "Expirado" && item.fechafin === null ? (
                                    <>
                                      <div
                                        className="btn_progreso"
                                        style={{
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <ButtonZegel
                                          label="Solicitar ampliación"
                                          color="primary"
                                          onClick={() => {
                                              setShowAmpliacion(true);
                                              setIdPersonaCursoSolicitudAmpliacion(item.idPersonaCurso)
                                            }
                                          }
                                        ></ButtonZegel>
                                      </div>
                                      <div className="btn_progreso">
                                        <ButtonZegel
                                          label="¡Seguir aprendiendo!"
                                          color="secondary"
                                          height="60px !important"
                                          onClick={() =>
                                            handleLinkClickCursoBase(
                                              item.idPersonaCurso
                                            )
                                          }
                                        ></ButtonZegel>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {item.idEstado == 3 ? (
                                        <div className="btn_progreso">
                                          <ButtonZegel
                                            label="Activar módulo"
                                            color="primary"
                                            onClick={() => {
                                              setShowAlert(true);
                                              setContenidoAlertActivar(
                                                contenidoActivar
                                              );
                                              setcursoActivarSeleccion(i);
                                            }}
                                          ></ButtonZegel>
                                        </div>
                                      ) : item.idEstado == 2 ? (
                                        <div className="btn_progreso">
                                          <ButtonZegel
                                            label="¡Seguir aprendiendo!"
                                            color="primary"
                                            height="60px !important"
                                            onClick={() =>
                                              handleLinkClickCursoBase(
                                                item.idPersonaCurso
                                              )
                                            }
                                          ></ButtonZegel>
                                        </div>
                                      ) : item.idEstado == 1 ? (
                                        <div className="divBottonAvance">
                                          <ButtonZegel
                                            label="Ver de nuevo"
                                            color="primary"
                                            onClick={() =>
                                              navigate(
                                                "/" +
                                                  PrivateRoutes.HOME +
                                                  "/CursoInterno/" +
                                                  item.idPersonaCurso
                                              )
                                            }
                                          ></ButtonZegel>
                                        </div>
                                      ) : (
                                        <div>
                                          <ButtonZegel
                                            label="Activar módulo"
                                            color="primary"
                                            onClick={() => {
                                              setShowAlert(true);
                                              setContenidoAlertActivar(
                                                contenidoActivar
                                              );
                                              setcursoActivarSeleccion(i);
                                            }}
                                          ></ButtonZegel>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                              {/* <div className="progreso_barra">
                                    <ProgresoProgramaCursoPormedioProgressBar idCurso={item.idCurso} Color="#6366F1"  className=""/>
                              </div> */}
                              <div
                                style={{
                                  marginTop:
                                    item.idEstado === 3
                                      ? 10
                                      : item.idEstado === 2
                                      ? 30
                                      : 10,
                                }}
                                className="progresoModuloDesktop progreso_barra"
                              >
                                <ProgresoProgramaCursoPormedioProgressBar
                                  idCurso={item.idCurso}
                                  Color="#6366F1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="field col-12 md:col-5">
                        {/* DESKTOP */}
                        <div className="p-fluid formgrid grid progreso-desktop-flex">
                          <div
                            className=" col-12 md:col-12"
                            style={{ paddingBottom: "15px" }}
                          >
                            <div
                              className="p-fluid formgrid grid"
                              style={{ paddingLeft: "6px" }}
                            >
                              <div
                                className=" col-12 md:col-10"
                                style={{
                                  paddingRight: 0,
                                  border: "#dee2e6 solid 1px",
                                }}
                              >
                                <div className=" rounded-9 shadow  p-md-4 mb-md-4 cardTabsArchivosMaterialesPrograma">
                                  <span
                                    className="subtitle text-sm h3 "
                                    style={{
                                      marginBottom: "7px",
                                      marginTop: "15px",
                                    }}
                                    data-v-48f3e599=""
                                  >
                                    Materiales del módulo
                                  </span>
                                </div>
                              </div>
                              <div
                                className=" col-12 md:col-2"
                                style={{ paddingLeft: 0 }}
                              >
                                <div
                                  className={
                                    /* item.idEstado != 3 &&
                                    isButtonDisabledMateriales == false
                                      ? */ 
                                      "flex align-items-center justify-content-center interna-material-download"
                                      //: "flex align-items-center justify-content-center interna-material-download-apagado"
                                  }
                                  style={{
                                    width: "77px",
                                    height: "100%",
                                  }}
                                  onClick={() => {
                                    /* if (
                                      item.idEstado != 3 &&
                                      isButtonDisabledMateriales == false
                                    ) { */
                                      handleDownloadMaterialesCurso(
                                        item.idCurso
                                      );
                                    //}
                                  }}
                                >
                                  {spinnerMateriales ? (
                                    <ProgressSpinner
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={iconDownload}
                                      width={"17.5px"}
                                      height={"21px"}
                                    ></img>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 md:col-12">
                            <div
                              className=" p-fluid formgrid grid progreso-desktop-flex materiales"
                              style={{ paddingLeft: "6px" }}
                            >
                              <div className="col-6 p-0">
                                <div
                                  className="flex interna-material w-full-progreso-programa "
                                  style={{
                                    paddingRight: 0,
                                    border: "#dee2e6 solid 1px",
                                  }}
                                >
                                  {/* esv 23-04-25 <div className="interna-material-info"> */}
                                  <div className="col-8 title-material-info mt-3">
                                    <span className="subtitle text-sm" style={{ marginTop: "0.5rem" }}>
                                      <b className="card_download_title">Certificado del módulo</b>
                                    </span>
                                  </div>
                                  <div className="col-4 p-0">
                                    <div
                                      className={
                                        puedeDescargar
                                          ? "flex align-items-center justify-content-center interna-material-download"
                                          : "flex align-items-center justify-content-center interna-material-download-apagado botonescursos"
                                      }
                                      style={{ width: "77px", height: "100%" }}
                                      onClick={() => {
                                        if (puedeDescargar) {
                                          onDownloadCertificado(item);
                                        }
                                      }}
                                    >
                                      <Tooltip
                                        target=".botonescursos"
                                        content={
                                          item.finCurso === null
                                            ? "Este botón se encuentra desactivado, dado que aún no terminas el módulo."
                                            : item.idCondicion === 2
                                              ? "Este botón se encuentra desactivado, dado que desaprobaste el módulo."
                                              : promedioNumerico < notaMinima
                                              ? `Este botón se encuentra desactivado, tu promedio es ${promedioNumerico} y necesitas al menos ${notaMinima} para aprobar.`
                                              : ""
                                        }
                                        className="white-tooltip"
                                        position="left"
                                      />
                                      {spinnerCertificado ? (
                                        <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                                      ) : (
                                        <img src={iconDownload} width={"17.5px"} height={"21px"} />
                                      )}
                                    </div>
                                  </div>

                                  {/* end esv 23-04-25 */}
                                </div>
                              </div>
                              <div className="col-6 p-0 pl-2">
                                <div
                                  className="flex interna-material w-full-progreso-programa "
                                  style={{
                                    paddingRight: 0,
                                    border: "#dee2e6 solid 1px",
                                  }}
                                >
                                  <div className="col-8" style={{marginTop: "1.5rem"}}>
                                    <span
                                      className="subtitle text-sm"
                                      data-v-48f3e599=""
                                    >
                                      <b className="card_download_title">
                                        Detalles de notas
                                      </b>
                                    </span>
                                  </div>
                                  <div className="col-4 p-0">
                                    {/* <ButtonZegel
                                      height="100%"
                                      label=""
                                      width="72px"
                                      color="Quaternary"
                                      disabled={
                                        item.idEstado == 1 ? false : true
                                      }
                                      onClick={() =>
                                        handleDownloadNotas(item.idCurso)
                                      }
                                    >
                                      <img
                                        src={iconDownload}
                                        width={"25px"}
                                        height={"30px"}
                                      ></img>
                                    </ButtonZegel> */}
                                    <div
                                      className={
                                        item.idEstado == 1 &&
                                        isButtonDisabledNotas == false &&
                                        item.idCondicion != 2 &&
                                        listaEvaluacionesUnidadeCursoPrograma &&
                                        calcularPromedioNotasPorUnidad(
                                          item.idCurso
                                        ) >=
                                          configuraciones?.filter(
                                            (z) =>
                                              z.codigo === "NOTA_MINIMA_APROB"
                                          )[0].valor
                                          ? "flex align-items-center justify-content-center interna-material-download"
                                          : "flex align-items-center justify-content-center interna-material-download-apagado botonescursos"
                                      }
                                      style={{
                                        width: "77px",
                                        height: "100%",
                                      }}
                                      onClick={() => {
                                        if (
                                          item.idEstado === 1 &&
                                          item.idCondicion != 2 &&
                                          listaEvaluacionesUnidadeCursoPrograma &&
                                          calcularPromedioNotasPorUnidad(
                                            item.idCurso
                                          ) >=
                                            configuraciones?.filter(
                                              (z) =>
                                                z.codigo === "NOTA_MINIMA_APROB"
                                            )[0].valor
                                        ) {
                                          handleDownloadNotas(item.idCurso);
                                        }
                                      }}
                                    >
                                      {spinnerNotas ? (
                                        <ProgressSpinner
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={iconDownload}
                                          width={"17.5px"}
                                          height={"21px"}
                                        ></img>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* DESKTOP */}
                        <div className="p-fluid formgrid grid mb-0 materiales_mobile">
                          <div className="border flex interna-material w-full mb-2">
                            <div className="interna-material-info card_download_title">
                              <span className=" text-sm h3" data-v-48f3e599="">
                                Materiales del módulo
                              </span>
                            </div>
                            <div
                              className={
                                /* item.idEstado != 3 &&
                                isButtonDisabledMateriales == false
                                  ? */ 
                                  "flex align-items-center justify-content-center interna-material-download"
                                  //: "flex align-items-center justify-content-center interna-material-download-apagado"
                              }
                              style={{
                                width: "77px",
                                height: "100%",
                              }}
                              onClick={() => {
                                /* if (
                                  item.idEstado != 3 &&
                                  isButtonDisabledMateriales == false
                                ) { */
                                  handleDownloadMaterialesCurso(item.idCurso);
                                //}
                              }}
                            >
                              {spinnerMateriales ? (
                                <ProgressSpinner
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={iconDownload}
                                  width={"17.5px"}
                                  height={"21px"}
                                ></img>
                              )}
                            </div>
                          </div>

                          <div className="border flex interna-material w-full mb-2">
                            <div className="interna-material-info card_download_title">
                              <span className=" text-sm h3" data-v-48f3e599="">
                                Certificado del módulo
                              </span>
                            </div>
                            {/* <ButtonZegel
                              height="100%"
                              label=""
                              width="77px"
                              color="Quaternary"
                              disabled={item.idEstado == 1 ? false : true}
                              onClick={() => handleDownloadNotas(item.idCurso)}
                            >
                              <img
                                src={iconDownload}
                                width={"25px"}
                                height={"30px"}
                              ></img>
                            </ButtonZegel> */}
                            <div
                              className={
                                item.idEstado == 1 &&
                                isButtonDisabledCertificado == false &&
                                item.idCondicion != 2 &&
                                listaEvaluacionesUnidadeCursoPrograma &&
                                calcularPromedioNotasPorUnidad(item.idCurso) >=
                                  configuraciones?.filter(
                                    (z) => z.codigo === "NOTA_MINIMA_APROB"
                                  )[0].valor
                                  ? "flex align-items-center justify-content-center interna-material-download"
                                  : "flex align-items-center justify-content-center interna-material-download-apagado"
                              }
                              style={{
                                width: "77px",
                                height: "100%",
                              }}
                              onClick={() => {
                                if (
                                  item.idEstado == 1 &&
                                  isButtonDisabledCertificado == false &&
                                  item.idCondicion != 2 &&
                                  listaEvaluacionesUnidadeCursoPrograma &&
                                  calcularPromedioNotasPorUnidad(
                                    item.idCurso
                                  ) >=
                                    configuraciones?.filter(
                                      (z) => z.codigo === "NOTA_MINIMA_APROB"
                                    )[0].valor
                                ) {
                                  onDownloadCertificado(item);
                                }
                              }}
                            >
                              {spinnerCertificado ? (
                                <ProgressSpinner
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={iconDownload}
                                  width={"17.5px"}
                                  height={"21px"}
                                ></img>
                              )}
                            </div>
                          </div>

                          <div className="border flex interna-material w-full mb-2">
                            <div className="interna-material-info card_download_title">
                              <span className=" text-sm h3" data-v-48f3e599="">
                                Detalles de notas
                              </span>
                            </div>
                            <div
                              className={
                                item.idEstado == 1 &&
                                isButtonDisabledNotas == false &&
                                item.idCondicion != 2 &&
                                listaEvaluacionesUnidadeCursoPrograma &&
                                calcularPromedioNotasPorUnidad(item.idCurso) >=
                                  configuraciones?.filter(
                                    (z) => z.codigo === "NOTA_MINIMA_APROB"
                                  )[0].valor
                                  ? "flex align-items-center justify-content-center interna-material-download"
                                  : "flex align-items-center justify-content-center interna-material-download-apagado"
                              }
                              style={{
                                width: "77px",
                                height: "100%",
                              }}
                              onClick={() => {
                                if (
                                  item.idEstado == 1 &&
                                  isButtonDisabledNotas == false &&
                                  item.idCondicion != 2 &&
                                  listaEvaluacionesUnidadeCursoPrograma &&
                                  calcularPromedioNotasPorUnidad(
                                    item.idCurso
                                  ) >=
                                    configuraciones?.filter(
                                      (z) => z.codigo === "NOTA_MINIMA_APROB"
                                    )[0].valor
                                ) {
                                  handleDownloadNotas(item.idCurso);
                                }
                              }}
                            >
                              {spinnerNotas ? (
                                <ProgressSpinner
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={iconDownload}
                                  width={"17.5px"}
                                  height={"21px"}
                                ></img>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="field col-12 md:col-7 mt-0">
                        <div
                          className="border rounded-9 shadow p-3 p-md-4  mb-md-4 cardTabs card3Y4min-height"
                          style={{ border: "#dee2e6 solid 1px" }}
                        >
                          <div className="row g-2 mb-2 align-items-center  ">
                            <TabView
                              className="tabviewProgreso "
                              style={{ marginBottom: "10px" }}
                              scrollable
                            >
                              {listaUnidadeCursoPrograma &&
                                listaUnidadeCursoPrograma
                                  .filter((x) => x.idCurso === item.idCurso)
                                  .map((itemu, i) => {
                                    return (
                                      <TabPanel
                                        key={i}
                                        header={"Unidad " + (i + 1)}
                                      >
                                        <span
                                          class="leccion_header fontsizeunset h4"
                                          data-v-48f3e599=""
                                          style={{ marginTop: "0" }}
                                        >
                                          {itemu.descripcion}
                                        </span>
                                        <p
                                          className="fontsizeunset"
                                          dangerouslySetInnerHTML={{
                                            __html: itemu.logro,
                                          }}
                                          style={{ marginBottom: "20px" }}
                                        />
                                        <p>
                                          <b className="fontsizeunset">
                                            Lecciones
                                          </b>
                                        </p>
                                        {listaLeccionUnidadeCursoPrograma
                                          .filter(
                                            (x) => x.idUnidad == itemu.idUnidad
                                          )
                                          .map((itemj, j) => {
                                            return (
                                              // <p>
                                              //   <span
                                              //     className="fontsizeunset"
                                              //     style={{ color: "#010101" }}
                                              //   >
                                              //     {"- Lección " +
                                              //       (j + 1) +
                                              //       ": "}
                                              //   </span>
                                              //   {item.idEstado != 2 ? (
                                              //     <span
                                              //       className="fontsizeunset"
                                              //       style={{
                                              //         color: "#7C7C7C",
                                              //       }}
                                              //     >
                                              //       {itemj.descripcion}
                                              //     </span>
                                              //   ) : (
                                              //     <a
                                              //       href=""
                                              //       onClick={() =>
                                              //         handleLinkClickCursos(
                                              //           item.idPersonaCurso,
                                              //           itemu,
                                              //           itemj
                                              //         )
                                              //       }
                                              //       // className="fontsizeunset"
                                              //       style={{
                                              //         color: "blue",
                                              //       }}
                                              //     >
                                              //       {itemj.descripcion}
                                              //     </a>
                                              //   )}
                                              // </p>
                                              <div className="contenido-lecciones">
                                                <span
                                                  className="lecciones"
                                                  style={{ color: "#010101" }}
                                                >
                                                  {"- Lección " +
                                                    (j + 1) +
                                                    ": "}
                                                </span>

                                                {item.idEstado != 2 ? (
                                                  <span
                                                    className="fontsizeunset"
                                                    style={{ color: "#7C7C7C" }}
                                                  >
                                                    {itemj.descripcion}
                                                  </span>
                                                ) : (
                                                  // <a href="" onClick={() => handleLinkClickCursos(item, itemj)} className="fontsizeunset">
                                                  //   {itemj.descripcion}
                                                  // </a>
                                                  // <Link className="fontsizeunset"
                                                  //   style={{
                                                  //     color: "blue",
                                                  //   }}
                                                  //   to={"/" + PrivateRoutes.HOME + "/CursoInterno/" + item.idPersonaCurso + "/" + itemu.idUnidad + "/" + itemj.idLeccion}>
                                                  //     {itemj.descripcion}
                                                  // </Link>

                                                  <Link
                                                    //className="fontsizeunset"
                                                    style={{
                                                      color: "blue",
                                                    }}
                                                    to={
                                                      "/" +
                                                      PrivateRoutes.HOME +
                                                      "/CursoInterno/" +
                                                      item.idPersonaCurso +
                                                      "/" +
                                                      itemu.idUnidad +
                                                      "/" +
                                                      itemj.idLeccion
                                                    }
                                                  >
                                                    {itemj.descripcion}
                                                  </Link>
                                                )}
                                              </div>
                                            );
                                          })}
                                      </TabPanel>
                                    );
                                  })}
                            </TabView>
                            {/* <TabView className="tabviewProgreso progreso-mobile" scrollable>
                              {listaUnidades.map((item, i) => {
                                return (
                                  <TabPanel key={i} header={"Unidad " + (i + 1)}>
                                    <h4
                                      class="subtitle fontsizeunset"
                                      data-v-48f3e599=""
                                      style={{ marginTop: "0" }}
                                    >
                                      {item.descripcion}
                                    </h4>
                                    <p
                                      className="fontsizeunset"
                                      dangerouslySetInnerHTML={{ __html: item.logro }}
                                    />
                                    <p>
                                      <b className="fontsizeunset">Lecciones</b>
                                    </p>
                                    {listaLecciones
                                      .filter((x) => x.idUnidad == item.idUnidad)
                                      .map((itemj, j) => {
                                        return (
                                          <p>
                                            <span
                                              className="fontsizeunset"
                                              style={{ color: "#010101" }}
                                            >
                                              {"- Lección " + (j + 1) + ": "}
                                            </span>
                                            {cursoPersona[0].idEstado != 2 ?
                                              (<span
                                                className="fontsizeunset"
                                                style={{ color: "#7C7C7C" }}
                                              >
                                                {itemj.descripcion}
                                              </span>) : (
                                                <a href="" onClick={() => handleLinkClickCursos(item, itemj)} className="fontsizeunset">
                                                  {itemj.descripcion}
                                                </a>
                                              )}
                                          </p>
                                        );
                                      })}
                                  </TabPanel>
                                );
                              })}
                            </TabView> */}
                          </div>
                        </div>
                      </div>

                      <div className="field col-12 md:col-5 progreso-desktop-block">
                        <div
                          className="border rounded-9 shadow p-md-4  mb-md-4 cardTabs card3Y4min-height card_contenedor_avance_desktop"
                          style={{ border: "#dee2e6 solid 1px" }}
                        >
                          <span class="subtitle h4 pb-3" data-v-48f3e599="">
                            Avance de unidades
                          </span>
                          <div style={{ marginLeft: "10px" }}>
                            {listaUnidadeCursoPrograma &&
                              listaUnidadeCursoPrograma
                                .filter((x) => x.idCurso === item.idCurso)
                                .map((itemu, i) => {
                                  return (
                                    <div className="p-fluid formgrid grid">
                                      <div
                                        className="field col-12 md:col-2"
                                        style={{
                                          paddingLeft: "0",
                                          paddingRight: "0",
                                        }}
                                      >
                                        <b className="fontsizesmall">
                                          {"Unidad " + (i + 1)}
                                        </b>
                                      </div>
                                      <div className="field col-12 md:col-5 bar-progress-unidades">
                                        {/* <Tooltip
                                          target={
                                            ".ProgressBar" + itemu.idUnidad
                                          }
                                          
                                          content={
                                            ProgresoUnidad.filter(
                                              (x) =>
                                                x.idUnidad == itemu.idUnidad
                                            )[0]
                                              ? ProgresoUnidad.filter(
                                                (x) =>
                                                  x.idUnidad == itemu.idUnidad
                                              )[0].promedioPorcentaje > 0
                                                ? "¡Termina tus videos! Aún no has culminado la(s) lección(es): " +
                                                LeccionesPendientes.filter(
                                                  (x) =>
                                                    x.idUnidad ==
                                                    itemu.idUnidad
                                                )[0].leccionesPendientes.join(
                                                  ","
                                                )
                                                : 
                                                ""
                                              : ""
                                          }
                                          className="white-tooltip"
                                        /> */}
                                        <ProgresoProgramaCursoUnidadPormedioProgressBar
                                          idCurso={item.idCurso}
                                          idUnidad={itemu.idUnidad}
                                        />
                                      </div>
                                      <div className="field col-12 md:col-1">
                                        <ProgresoProgramaCursoUnidadPormedio
                                          idCurso={item.idCurso}
                                          idUnidad={itemu.idUnidad}
                                        />
                                      </div>
                                      {/* <div className="field col-12 md:col-4">

                                        <UnidadEvaluacion
                                          idCurso={item.idCurso}
                                          idUnidad={itemu.idUnidad}
                                        />
                                      </div> */}
                                      <div
                                        className="field col-12 md:col-4"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <UnidadEvaluacion
                                          idCurso={item.idCurso}
                                          idUnidad={itemu.idUnidad}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                          </div>
                          <span class="subtitle h4" data-v-48f3e599="">
                            <span>
                              { calcularPromedioNotasPorUnidad(item.idCurso) }
                            </span>
                            
                          </span>
                        </div>
                      </div>

                      <div className="field col-12 md:col-5 progreso-mobile">
                        <div className="border rounded-9 shadow p-3 p-md-4 mb-md-4 cardTabs">
                          <span
                            class=" title_avance_unidades"
                            data-v-48f3e599=""
                          >
                            Avance de unidades
                          </span>
                          {listaUnidadeCursoPrograma &&
                            listaUnidadeCursoPrograma
                              .filter((x) => x.idCurso === item.idCurso)
                              .map((itemu, i) => {
                                return (
                                  <Avance
                                    itemu={itemu}
                                    item={item}
                                    i={i}
                                    listaProgresoLeccionUnidadeCursoPrograma={
                                      listaProgresoLeccionUnidadeCursoPrograma
                                    }
                                    listaLeccionUnidadeCursoPrograma={
                                      listaLeccionUnidadeCursoPrograma
                                    }
                                    listaEvaluacionesUnidadeCursoPrograma={
                                      listaEvaluacionesUnidadeCursoPrograma
                                    }
                                  />
                                );
                              })}
                          <span class="subtitle h4" data-v-48f3e599="">
                            <span>
                              { calcularPromedioNotasPorUnidad(item.idCurso) }
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionTab>
              );
            })}
        </Accordion>
        <DialogZegel
          header=""
          visible={showAlert}
          width="30vw"
          onHide={() => setShowAlert(false)}
          footer={footerActivar}
          contenido={contenidoAlertActivar}
        ></DialogZegel>
        <DialogZegel
          header=""
          visible={showAmpliacion}
          width="30vw"
          onHide={() => setShowAmpliacion(false)}
          footer={footerAmpliacion}
          contenido={contenidoAmpliacion}
        ></DialogZegel>
        <DialogZegel
          header=""
          visible={showErrorMateriales}
          width="30vw"
          onHide={() => setShowErrorMateriales(false)}
          footer={footerErrorMateriales}
          contenido={contenidoErrorMateriales}
        ></DialogZegel>
      </div>
    </div>
  );
}

export default ModulosAcordionProgramaComponent;
